module.exports = __webpack_public_path__ + "img/P27920580Yling.5140493e.jpg";